module.exports = __webpack_public_path__ + "img/logo_black.bcf5d2a2.png";